/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import ErrorDto from '../model/ErrorDto';
import ErrorResponse from '../model/ErrorResponse';
import PageDetailsDto from '../model/PageDetailsDto';
import PageDto from '../model/PageDto';
import PageInputDto from '../model/PageInputDto';
import PaginatedPagesDto from '../model/PaginatedPagesDto';

/**
* Page service.
* @module api/PageApi
* @version v0
*/
export default class PageApi {

    /**
    * Constructs a new PageApi. 
    * @alias module:api/PageApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createPage operation.
     * @callback module:api/PageApi~createPageCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PageDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a new page
     * @param {module:model/PageInputDto} pageInputDto 
     * @param {module:api/PageApi~createPageCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PageDto}
     */
    createPage(pageInputDto, callback) {
      let postBody = pageInputDto;
      // verify the required parameter 'pageInputDto' is set
      if (pageInputDto === undefined || pageInputDto === null) {
        throw new Error("Missing the required parameter 'pageInputDto' when calling createPage");
      }

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*', 'application/json'];
      let returnType = PageDto;
      return this.apiClient.callApi(
        '/api/private/page', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deletePageById operation.
     * @callback module:api/PageApi~deletePageByIdCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a page by ID
     * @param {Number} id ID of the page to delete
     * @param {module:api/PageApi~deletePageByIdCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deletePageById(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deletePageById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/api/private/page/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getPageById operation.
     * @callback module:api/PageApi~getPageByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PageDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a page by ID
     * @param {Number} id ID of the page to update
     * @param {module:api/PageApi~getPageByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PageDto}
     */
    getPageById(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getPageById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = PageDto;
      return this.apiClient.callApi(
        '/api/private/page/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getPageDetailsById operation.
     * @callback module:api/PageApi~getPageDetailsByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PageDetailsDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a page with its questions and respective answers by page ID
     * @param {Number} id ID of the page to retrieve.
     * @param {module:api/PageApi~getPageDetailsByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PageDetailsDto}
     */
    getPageDetailsById(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getPageDetailsById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = PageDetailsDto;
      return this.apiClient.callApi(
        '/api/private/page/{id}/details', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getPages operation.
     * @callback module:api/PageApi~getPagesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PaginatedPagesDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all pages
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page Page number
     * @param {Number} opts.limit Number of items per page
     * @param {String} opts.type Filter by type
     * @param {Number} opts.categoryId Filter by category id
     * @param {String} opts.title Filter by title
     * @param {Boolean} opts.enabled Filter enabled
     * @param {module:api/PageApi~getPagesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PaginatedPagesDto}
     */
    getPages(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'page': opts['page'],
        'limit': opts['limit'],
        'type': opts['type'],
        'category_id': opts['categoryId'],
        'title': opts['title'],
        'enabled': opts['enabled']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = PaginatedPagesDto;
      return this.apiClient.callApi(
        '/api/private/page', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getRandomPageByTypes operation.
     * @callback module:api/PageApi~getRandomPageByTypesCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PageDetailsDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a random page filtered with an array of types and exclusions for a specific game session.
     * @param {Number} sessionId ID of the game session
     * @param {Array.<String>} types Array of types to include to the random page selection
     * @param {Object} opts Optional parameters
     * @param {Array.<Number>} opts.exclusions Array of page IDs to exclude from the random selection
     * @param {module:api/PageApi~getRandomPageByTypesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PageDetailsDto}
     */
    getRandomPageByTypes(sessionId, types, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'sessionId' is set
      if (sessionId === undefined || sessionId === null) {
        throw new Error("Missing the required parameter 'sessionId' when calling getRandomPageByTypes");
      }
      // verify the required parameter 'types' is set
      if (types === undefined || types === null) {
        throw new Error("Missing the required parameter 'types' when calling getRandomPageByTypes");
      }

      let pathParams = {
      };
      let queryParams = {
        'sessionId': sessionId,
        'types': this.apiClient.buildCollectionParam(types, 'multi'),
        'exclusions': this.apiClient.buildCollectionParam(opts['exclusions'], 'multi')
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = PageDetailsDto;
      return this.apiClient.callApi(
        '/api/private/page/random', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the updatePageById operation.
     * @callback module:api/PageApi~updatePageByIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PageDto} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update an existing page
     * Update an existing page by ID
     * @param {Number} id ID of the page to update
     * @param {module:model/PageDto} pageDto 
     * @param {module:api/PageApi~updatePageByIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PageDto}
     */
    updatePageById(id, pageDto, callback) {
      let postBody = pageDto;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updatePageById");
      }
      // verify the required parameter 'pageDto' is set
      if (pageDto === undefined || pageDto === null) {
        throw new Error("Missing the required parameter 'pageDto' when calling updatePageById");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = ['application/json'];
      let accepts = ['*/*', 'application/json'];
      let returnType = PageDto;
      return this.apiClient.callApi(
        '/api/private/page/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
